/**
 * Created by Josef Jurca on 02/08/2017.
 */

import {ActionTypes, ImagesQueueStatuses} from 'store/actions/imagesqueue';

const defaultImageQueueState = {
    status: ImagesQueueStatuses.INITIAL,
    queue: []
};

/**
 * Sets imagesqueue status.
 *
 * @param {Object} state - State.
 * @param {Object} action - Action.
 * @return {string} - New state.
 */
function setStatus (state = ImagesQueueStatuses.INITIAL, action) {

    if (action.status) {
        state = action.status;
    }

    return state;
}

/**
 * Adds image to imagesqueue.
 *
 * @param {Object} state - State.
 * @param {Object} action - Action.
 * @return {string} - New state.
 */
function addImage (state = [], action) {

    if (!state.includes(action.id)) {
        state = [...state, action.id];
    }

    return state;
}

/**
 * Removes image to imagesqueue.
 *
 * @param {Object} state - State.
 * @param {Object} action - Action.
 * @return {string} - New state.
 */
function removeImage (state = [], action) {
    let newState = state,
        index = newState.indexOf(action.id);

    if (index > -1) {
        newState.splice(index, 1);
    }

    return [...newState];

}



/**
 * Session reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Session reducer.
 */
function imagesqueue (state = defaultImageQueueState, action) {

    switch (action.type) {

        case ActionTypes.ADD:
            return {
                ...state,
                queue: addImage(state.queue, action)
            };

        case ActionTypes.REMOVE:

            if (state.queue.length === 1 && (action.id && action.id === state.queue.pop())) {
                return {
                    status: setStatus(state.status, {status : ImagesQueueStatuses.LOADING_FINISHED}),
                    queue: removeImage(state.queue, action)
                };
            }

            return {
                ...state,
                queue: removeImage(state.queue, action)
            };

        case ActionTypes.SET_LOADING_STATUS:
            return {
                ...state,
                status: setStatus(state.status, action)
            };

        default:
            return state;
    }
}

export default imagesqueue;


// WEBPACK FOOTER //
// ./src/js/store/reducers/imagesqueue.js